document.addEventListener('DOMContentLoaded', () => {
  $('#ranks-table').DataTable({
    fixedHeader: true,
    order: []
  })
})
